import React, { Component } from 'react';
import classNames from 'classnames';

import Form from './PatientForm';
import LoadMask from 'Utils/LoadMask/LoadMask';

export default class BankAccountCrear extends Component {

    state = {
        editar: false,
        mensaje: 'Agregar cuenta bancaria',
        password: false,
    };

    componentWillMount(){

        const {
            createInitialize
        } = this.props;

        createInitialize();

        if (this.props.match.params.id) {
            this.props.detail(this.props.match.params.id);
            this.setState({
                editar: true,
                mensaje: 'Editar cuenta bancaria',
            });
        }
    }

    render() {
        const {
            create,
            update,
            cargando,
            updateData,
            municipios,
            isNavBarOpen,
            validateNit,
            setDataName,
            getAfiliationData,
            getDataWithCui,
            patient_image,
            verify_renap
        } = this.props;

        return (
            <div className={classNames('content', { 'content-min': isNavBarOpen })}>
                <div className="m-auto row-fluid card-form">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <div className="fields">
                                        <div className="top-title">
                                            PACIENTES
                                        </div>
                                        <Form
                                            getAfiliationData={getAfiliationData}
                                            municipios={municipios}
                                            onSubmit={update}
                                            updateData={updateData}
                                            validateNit={validateNit}
                                            setDataName={setDataName}
                                            editando={true}
                                            getDataWithCui={getDataWithCui}
                                            patient_image={patient_image}
                                            verify_renap={verify_renap}
                                        />
                                    </div>
                                :
                                    <div className="fields">
                                        <div className="top-title">
                                            CREAR PACIENTE
                                        </div>
                                        <Form 
                                            getAfiliationData={getAfiliationData}
                                            getDataWithCui={getDataWithCui}
                                            municipios={municipios}
                                            onSubmit={create}
                                            validateNit={validateNit}
                                            setDataName={setDataName}
                                            patient_image={patient_image}
                                            verify_renap={verify_renap}
                                        />
                                    </div>
                            }
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
